import request from "@/utils/request";

export function getMaterialListApi(params) {
  return request({
    url: "?c=mm&a=material&do=list",
    method: "get",
    params
  })
}

export function getMaterialApi(params) {
  return request({
    url: "?c=mm&a=material&do=get",
    method: "get",
    params
  })
}

export function postMaterialApi(data) {
  return request({
    url: "?c=mm&a=material&do=post",
    method: "post",
    data
  })
}

export function delMaterialApi(data) {
  return request({
    url: "?c=mm&a=material&do=del",
    method: "post",
    data
  })
}

export function importMaterialApi(data) {
  return request({
    url: "?c=mm&a=material&do=import",
    method: "post",
    data
  })
}

export function exportMaterialApi(params) {
  return request({
    url: "?c=mm&a=material&do=export",
    method: "get",
    params
  })
}

export function precreateMaterialNoApi(params) {
  return request({
    url: "?c=mm&a=material&do=precreate",
    method: "get",
    params
  })
}

